module.exports = "data:image/gif;base64,R0lGODlhFAAUAIABAM3Nzf///yH5BAEAAAEALAAAAAAUABQAAAIbjI+pywoPowSt2ouznhzqD4Zh14nmiRokl4oFADs="